import { InfoBox } from '../../../react4xp/parts/info-box/info-box'

export default (props) => <InfoBox {...props} />
